// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import DOMPurify from 'dompurify';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertDialogComponent {
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: IAlertDialogData,
      private translate: TranslateService) {

    this.translate.get(['ALERT_OK', 'CANCEL_CAP']).subscribe(vals => {
        data.rejectBtnName = data.rejectBtnName ? data.rejectBtnName : vals['CANCEL_CAP'];
        data.acceptBtnName = data.acceptBtnName ? data.acceptBtnName : vals['ALERT_OK'];
    });

  }

  getUnsafeHTML() {
    return DOMPurify.sanitize(this.data.unsafeHTML);
  }
}

export interface IAlertDialogData {
  title: string;
  titleRight?: string;
  unsafeHTML: string;
  content: string;
  additionalContent: Array<string>;
  acceptBtnName: string;
  rejectBtnName: string;
  showRejectBtn: boolean;
}
